<template>
    <div class="jumbotron regala-hero">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <h1 class="text-primary">Jamás tan poco transformó tantos corazones</h1>
                    <h5>
                        Regalando <i>ketarim</i> ayudas a que otros <i>yehudim</i> iluminen sus vidas estudiando el Talmud y, además, nos ayudas a desarrollar la nueva generación de la plataforma Jabrutouch.
                    </h5>
                </div>
                <div class="col-md-6" id="video">
                    <!-- <a href="#" @click.prevent="$store.state.videoVisible = true"><img :src="require('../assets/images/spoons.png')" class="img-fluid"></a> -->
                    <a href="#" @click.prevent="$store.state.videoVisible = true"><img :src="require('../assets/images/miniaturaweb.png')" class="img-fluid"></a>
                </div>
            </div>
        </div>
        <donations id="donations"/>
        <lightbox :url="'https://www.youtube.com/embed/VJIgISKmr0s'"/>
    </div>
</template>
<script>
import Donations from './Donations'

export default {
    components: {
        Donations
    }

}
</script>
<style lang="scss">
    .jumbotron.regala-hero{
        background: linear-gradient(189.01deg, rgba(255, 255, 255, 0.4) 6.97%, rgba(255, 255, 255, 0) 93.54%), #67C8C8;
        border-radius: 0;
    }
    @media (min-width: 544px) {
        .jumbotron.regala-hero{
            h1{
                font-size: 60px;
                line-height: 80px;
            }
            h5{
                font-weight: 400;
                color: #333333;
            }
        }
    }
</style>